<template>
  <ui-popover root-class="rd-menu" panel-class="rd-pop--menu" :label="label">
    <template #trigger="{ attrs, on }">
      <button
        type="button"
        class="ui-btn"
        :class="{ 'ui-btn--sm': size === 'sm', 'ui-btn--accent': partial }"
        v-bind="attrs"
        :aria-label="label"
        :disabled="!items.length"
        v-on="on"
      >
        <v-icon size="16">{{ icon }}</v-icon>
        <span class="rd-menu__label">{{ label }}</span>
        <b v-if="partial" class="rd-num">{{ selectedCount }}/{{ items.length }}</b>
        <v-icon size="16">mdi-chevron-down</v-icon>
      </button>
    </template>

    <template #default="{ close }">
      <div class="rd-pop__head">
        <span>{{ label }}</span>
        <span class="rd-num">{{ selectedCount }}/{{ items.length }}</span>
      </div>
      <div class="rd-checklist" role="group" :aria-label="label">
        <label v-for="item in items" :key="item.value">
          <input type="checkbox" :checked="value.includes(item.value)" @change="toggleItem(item.value, $event)" />
          <span :title="item.text">{{ item.text }}</span>
        </label>
      </div>
      <div class="rd-pop__links">
        <button type="button" class="ui-text-btn" @click="$emit('input', items.map((item) => item.value))">
          {{ $t("report_mobile.all") }}
        </button>
        <button type="button" class="ui-text-btn rd-pop__done" @click="close(true)">
          {{ $t("report_desktop.done") }}
        </button>
      </div>
    </template>
  </ui-popover>
</template>

<script>
/**
 * Dugme sa iskačućim spiskom kvačica u traci alata ekrana (npr. kolone tabele ili grupe jela). Ne drži izbor:
 * dobija `value` (niz izabranih vrednosti) i javlja `input`. U traci filtera ide u punoj veličini (`size="md"`),
 * a `min` je najmanje izabranih stavki (poslednja se ne može isključiti).
 */
export default {
  name: "ReportChecklistMenu",
  props: {
    label: { type: String, required: true },
    /** [{ value, text }] */
    items: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
    icon: { type: String, default: "mdi-view-column-outline" },
    size: { type: String, default: "sm" },
    min: { type: Number, default: 0 },
  },
  computed: {
    selectedCount() {
      return this.items.filter((item) => this.value.includes(item.value)).length;
    },
    partial() {
      return this.items.length > 0 && this.selectedCount < this.items.length;
    },
  },
  methods: {
    toggleItem(value, event) {
      const next = this.value.includes(value)
        ? this.value.filter((item) => item !== value)
        : [...this.value, value];
      if (next.length < this.min) {
        // izbor se ne menja, pa Vue ne bi vratio kvačicu koju je korisnik upravo skinuo
        if (event && event.target) {
          event.target.checked = true;
        }
        return;
      }
      // redosled stavki ostaje kao u spisku
      this.$emit(
        "input",
        this.items.map((item) => item.value).filter((item) => next.includes(item))
      );
    },
  },
};
</script>
